export default class StorageUtil {
    static setItem(key, val, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        adapter.setItem(key, JSON.stringify(val));
    }

    static getItem(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const val = adapter.getItem(key);
        try {
            return JSON.parse(val);
        } catch (err) {
            return val;
        }

    }

    static delItem(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        adapter.removeItem(key);
    }

    /**
     * 设置带过期时间的缓存（性能优化：TTL缓存机制）
     * @param key 缓存键
     * @param val 缓存值
     * @param ttlSeconds 过期时间（秒）
     * @param isSession 是否使用sessionStorage
     */
    static setItemWithTTL(key, val, ttlSeconds, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const item = {
            value: val,
            expiry: Date.now() + ttlSeconds * 1000,
            createTime: Date.now()
        };
        adapter.setItem(key, JSON.stringify(item));
    }

    /**
     * 获取带过期检查的缓存（性能优化：自动过期检查）
     * @param key 缓存键
     * @param isSession 是否使用sessionStorage
     * @returns 缓存值或null（已过期或不存在）
     */
    static getItemWithTTL(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const itemStr = adapter.getItem(key);
        if (!itemStr) return null;

        try {
            const item = JSON.parse(itemStr);
            if (item.expiry && Date.now() > item.expiry) {
                adapter.removeItem(key);
                return null;
            }
            return item.value;
        } catch (err) {
            return null;
        }
    }

    /**
     * 清除所有过期的缓存（性能优化：定期清理）
     * @param isSession 是否使用sessionStorage
     */
    static clearExpiredCache(isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const keys = Object.keys(adapter);
        keys.forEach(key => {
            const itemStr = adapter.getItem(key);
            if (itemStr) {
                try {
                    const item = JSON.parse(itemStr);
                    if (item.expiry && Date.now() > item.expiry) {
                        adapter.removeItem(key);
                    }
                } catch (err) {
                    // 非TTL格式缓存，忽略
                }
            }
        });
    }

    /**
     * 检查缓存是否有效（性能优化：缓存有效性检查）
     * @param key 缓存键
     * @param isSession 是否使用sessionStorage
     * @returns Boolean 是否有效
     */
    static isCacheValid(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const itemStr = adapter.getItem(key);
        if (!itemStr) return false;

        try {
            const item = JSON.parse(itemStr);
            if (item.expiry) {
                return Date.now() < item.expiry;
            }
            return true; // 无TTL的缓存，默认有效
        } catch (err) {
            return false;
        }
    }
}
// 定制setItemEvent事件，用于页面监听localStorage变化
var orignalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
    var setItemEvent = new Event("setItemEvent");
    setItemEvent.key = key;
    setItemEvent.newValue = newValue;
    window.dispatchEvent(setItemEvent);
    orignalSetItem.apply(this, arguments);
};



// WEBPACK FOOTER //
// ./src/utils/storage-util.js